.fullHeight {

}

.fullHeightTableContainer {
  display: flex;
  flex-direction: column;
  max-width: 100%;
  min-width: 0;
}

.fitContentTableContainer {
  overflow-x: auto;
  overflow-y: visible;
  max-width: 100%;
  border: 1px solid #e9ecef;
  border-radius: 8px;
  background-color: #fff;
}

/* ---------- Page header ---------- */

.pageHeader {
  margin: 10px 0 20px 0;
}

.pageHeaderMain {
  display: flex;
  flex-direction: column;
  align-items: flex-start;
  gap: 12px;
}

.pageTitle {
  margin-bottom: 2px;
  font-weight: 700;
}

.pageSubtitle {
  color: #6c757d;
  font-size: 14px;
  margin: 0;
}

.headerActions,
.tableToolbarActions {
  display: flex;
  gap: 8px;
  align-items: center;
  flex-shrink: 0;
}

.tableToolbar {
  display: flex;
  align-items: center;
  justify-content: space-between;
  gap: 16px;
  margin-bottom: 16px;
  min-width: 0;
}

.columnsDropdownToggle {
  display: inline-flex;
  align-items: center;
  gap: 6px;
}

.columnsDropdownMenu {
  padding: 0;
  min-width: 220px;
  max-height: 420px;
  overflow: hidden;
}

.columnsDropdownBody {
  padding: 10px 14px;
  max-height: 400px;
  overflow-y: auto;
  font-size: 13px;
  line-height: 1.3;
}

.columnsDropdownBody label {
  font-size: 13px;
  margin-bottom: 0;
  padding-bottom: 6px;
}

.columnsDropdownBody input[type='checkbox'] {
  width: 14px;
  height: 14px;
  margin-top: 2px;
}

.columnsSelectorEmbedded {
  padding-bottom: 0 !important;
}

/* ---------- Tabs ---------- */

.tabsBar {
  margin-bottom: 12px;
  padding-bottom: 0;
  min-width: 0;
  max-width: 100%;
}

.tabsRow {
  margin-bottom: 0;
  overflow-x: auto;
  flex-wrap: nowrap;
}

.tabsRow:global(.nav-tabs) {
  border-bottom: 1px solid #dee2e6;
}

.tabsBar .tabLink {
  display: inline-flex;
  align-items: center;
  gap: 7px;
  cursor: pointer;
  font-size: 14px;
  color: #6c757d;
  font-weight: 500;
  border: none !important;
  border-bottom: 2px solid transparent !important;
  border-radius: 0 !important;
  padding: 10px 16px 8px;
  margin-bottom: -1px;
  background-color: transparent !important;
  box-shadow: none !important;
  transition: color 0.15s ease, border-color 0.15s ease;
}

.tabsBar .tabLink:hover {
  color: #495057;
  background-color: transparent !important;
  border-bottom-color: transparent !important;
}

.tabsBar .tabLinkActive,
.tabsBar .tabLinkActive:hover {
  color: #0d6efd !important;
  font-weight: 600;
  background-color: transparent !important;
  border-bottom: 2px solid #0d6efd !important;
}

.tabDot {
  display: inline-block;
  width: 8px;
  height: 8px;
  border-radius: 50%;
}

.tabDotGreen {
  background-color: #28a745;
}

.tabDotAmber {
  background-color: #ffc107;
}

.tabDotRed {
  background-color: #dc3545;
}

.tabDotGrey {
  background-color: #adb5bd;
}

.tabCount {
  background-color: #f1f3f5;
  color: #495057;
  border-radius: 10px;
  padding: 1px 8px;
  font-size: 14px;
  font-weight: 600;
}

.tabsBar .tabLinkActive .tabCount {
  background-color: #e7f1ff;
  color: #0d6efd;
}

/* ---------- Search (toolbar row) ---------- */

.searchControls {
  display: flex;
  align-items: center;
  gap: 8px;
  margin-left: auto;
  flex: 0 1 auto;
  min-width: 0;
}

.searchScopeToggle {
  display: inline-flex;
  border: 1px solid #ced4da;
  border-radius: 6px;
  overflow: hidden;
  flex-shrink: 0;
  background-color: #fff;
}

.searchScopeBtn {
  border: 0;
  background: transparent;
  color: #6c757d;
  font-size: 13px;
  font-weight: 500;
  line-height: 1.2;
  padding: 6px 10px;
  cursor: pointer;
  white-space: nowrap;
}

.searchScopeBtn + .searchScopeBtn {
  border-left: 1px solid #ced4da;
}

.searchScopeBtn:hover {
  background-color: #f8f9fa;
  color: #343a40;
}

.searchScopeBtnActive {
  background-color: #e7f1ff;
  color: #0d6efd;
  font-weight: 600;
}

.searchScopeBtnActive:hover {
  background-color: #e7f1ff;
  color: #0d6efd;
}

.searchWrap {
  position: relative;
  width: 240px;
  min-width: 160px;
  max-width: 240px;
  flex: 0 1 240px;
}

.searchInput {
  width: 100%;
  max-width: 100%;
  box-sizing: border-box;
  padding: 6px 12px 6px 32px;
  border: 1px solid #ced4da;
  border-radius: 6px;
  font-size: 14px;
}

.searchIcon {
  position: absolute;
  left: 10px;
  top: 50%;
  transform: translateY(-50%);
  color: #adb5bd;
  pointer-events: none;
}

.searchScopeHint {
  margin: -8px 0 12px 0;
  color: #6c757d;
  font-size: 13px;
}

/* ---------- Metric cards (traffic-light order: green, amber, red) ---------- */

.metricsRow {
  display: flex;
  gap: 15px;
  margin-bottom: 20px;
  flex-wrap: wrap;
}

.metricCard {
  flex: 1;
  min-width: 170px;
  display: flex;
  gap: 14px;
  align-items: center;
  padding: 16px 18px;
  border: 1px solid #e9ecef;
  border-radius: 8px;
  background-color: #fff;
}

.metricCard[role='button'] {
  cursor: pointer;
}

.metricCard[role='button']:hover {
  box-shadow: 0 2px 6px rgba(0, 0, 0, 0.12);
}

.metricCardActive {
  border-color: #0d6efd;
  box-shadow: 0 0 0 1px #0d6efd;
}

.metricIcon {
  display: flex;
  align-items: center;
  justify-content: center;
  width: 64px;
  height: 64px;
  min-width: 64px;
  min-height: 64px;
  border-radius: 50%;
  flex-shrink: 0;
}

.metricIconSvg {
  width: 40px !important;
  height: 40px !important;
  min-width: 40px;
  min-height: 40px;
  display: block;
  flex-shrink: 0;
}

.metricIconGreen {
  background-color: #e6f4ea;
}

.metricIconAmber {
  background-color: #fff3cd;
}

.metricIconRed {
  background-color: #f8d7da;
}

.metricIconBlue {
  background-color: #e7f1ff;
}

.metricIconPurple {
  background-color: #f1e8fb;
}

.metricLabel {
  font-size: 14px;
  color: #495057;
}

.metricValue {
  font-size: 26px;
  font-weight: 700;
  line-height: 1.2;
  color: #212529;
}

.metricCaption {
  font-size: 14px;
  color: #6c757d;
}

/* ---------- Status badges / pills ---------- */

.statusBadge {
  display: inline-flex;
  align-items: center;
  gap: 6px;
  padding: 2px 10px;
  border-radius: 10px;
  font-size: 14px;
  font-weight: 600;
  white-space: nowrap;
}

.statusBadge::before {
  content: '';
  width: 6px;
  height: 6px;
  border-radius: 50%;
  background-color: currentColor;
}

.statusBadgeGreen {
  background-color: #e6f4ea;
  color: #1e7e34;
}

.statusBadgeAmber {
  background-color: #fff3cd;
  color: #856404;
}

.statusBadgeRed {
  background-color: #f8d7da;
  color: #bd2130;
}

.statusBadgeBlue {
  background-color: #e7f1ff;
  color: #0b5ed7;
}

.statusBadgeNeutral {
  background-color: #e9ecef;
  color: #495057;
}

.errorPill {
  display: inline-block;
  max-width: 220px;
  overflow: hidden;
  text-overflow: ellipsis;
  white-space: nowrap;
  background-color: #f8d7da;
  color: #bd2130;
  border-radius: 10px;
  padding: 2px 10px;
  font-size: 13px;
  font-weight: 600;
  vertical-align: middle;
}

/* Soft/retryable failures — stay on Active; distinct from fatal red pills */
.errorPillRetryable {
  background-color: #fff3cd;
  color: #856404;
}

/* ---------- Table cells ---------- */

.nameCell {
  min-width: 160px;
}

.nameText {
  color: #0d6efd;
  font-weight: 600;
}

.nameId {
  color: #adb5bd;
  font-size: 14px;
}

.cellSub {
  color: #6c757d;
  font-size: 13px;
  margin-top: 3px;
}

.workflowsTable select,
.workflowsTable input {
  margin-top: 5px;
  width: 100%;
}

.workflowsTable:global(.table) {
  --bs-table-color: #000;
  --bs-table-bg: #fff;
  --bs-table-accent-bg: transparent;
  width: 100%;
  table-layout: auto;
  border-collapse: separate;
  border-spacing: 0;
  margin-bottom: 0;
  background-color: #fff;
  color: #000;
}

.tableHeaderCell {
  position: sticky;
  top: 0;
  z-index: 2;
  background-color: #f8f9fa !important;
  color: #000 !important;
  --bs-table-bg: #f8f9fa;
  --bs-table-color: #000;
  --bs-table-accent-bg: transparent;
  border-bottom: 1px solid #dee2e6;
  white-space: nowrap;
  vertical-align: middle !important;
  font-size: 14px;
  font-weight: 700 !important;
  cursor: pointer;
  user-select: none;
}

.tableFilterCell {
  position: sticky;
  top: 34px;
  z-index: 1;
  background-color: #fff !important;
  color: #000 !important;
  --bs-table-bg: #fff;
  --bs-table-color: #000;
  --bs-table-accent-bg: transparent;
  border-bottom: 1px solid #dee2e6;
  cursor: default;
  font-weight: 400 !important;
}

.tableBodyCell {
  background-color: #fff !important;
  color: #000 !important;
  --bs-table-bg: #fff;
  --bs-table-color: #000;
  --bs-table-accent-bg: transparent;
  vertical-align: middle;
  font-size: 14px;
}

.tableBodyCell .nameText,
.tableBodyCell .nameId,
.tableBodyCell .cellSub,
.tableBodyCell .statusBadge,
.tableBodyCell .errorPill {
  font-size: 14px;
}

.headerLabel {
  display: inline-flex;
  align-items: center;
  gap: 5px;
  font-weight: 700;
  color: #000;
}

.sortIndicator {
  color: #adb5bd;
  font-size: 11px;
}

.sortIndicatorActive {
  color: #0d6efd;
}

.filterRow th {
  top: 34px;
  cursor: default;
}

/* ---------- Table footer / pagination ---------- */

.footerBar {
  display: flex;
  align-items: center;
  justify-content: flex-start;
  gap: 16px;
  padding: 12px 4px;
  font-size: 13px;
  color: #6c757d;
  flex-wrap: wrap;
}

.pageButtons {
  display: flex;
  align-items: center;
  gap: 5px;
}

.pageBtn {
  min-width: 30px;
  height: 30px;
  padding: 0 6px;
  border: 1px solid #dee2e6;
  border-radius: 5px;
  background-color: #fff;
  color: #495057;
  font-size: 13px;
  cursor: pointer;
}

.pageBtn:disabled {
  opacity: 0.5;
  cursor: default;
}

.pageBtnActive {
  background-color: #0d6efd;
  border-color: #0d6efd;
  color: #fff;
}

.pageSizeSelect {
  height: 30px;
  border: 1px solid #dee2e6;
  border-radius: 5px;
  background-color: #fff;
  color: #495057;
  font-size: 13px;
}

/* ---------- Row actions ---------- */

.actionsCell {
  white-space: nowrap;
  width: auto;
  min-width: 305px;
  overflow: visible;
}

.actionButton {
  height: 38px;
  margin: 5px;
  color: #fff;
}

/* Workflow row actions: green = clickable, red = disabled */
.actionButtonEnabled {
  background-color: #28a745;
  border-color: #28a745;
}

.actionButtonEnabled:hover:not(:disabled) {
  background-color: #218838;
  border-color: #1e7e34;
  color: #fff;
}

.actionButtonDisabled {
  background-color: #dc3545;
  border-color: #dc3545;
  opacity: 0.85;
}

.actionButtonDisabled:hover:not(:disabled) {
  background-color: #c82333;
  border-color: #bd2130;
  color: #fff;
}

.actionButton svg {
  margin: -3px -4px 2px -8px;
  width: 25px;
}

.actionsRow {
  display: flex;
  flex-wrap: wrap;
  align-items: center;
  width: 305px;
}

/* ---------- Archive confirm (in-progress feedback) ---------- */

.archiveProcessing {
  display: flex;
  align-items: flex-start;
  gap: 14px;
}

.archiveProcessingSpinner {
  width: 28px;
  height: 28px;
  flex-shrink: 0;
  margin-top: 2px;
}

.archiveProcessingTitle {
  font-weight: 600;
  margin-bottom: 4px;
}

.archiveProcessingCaption {
  color: #6c757d;
  font-size: 14px;
  line-height: 1.4;
}

/* ---------- Modal ---------- */

.workflowModal {
  max-width: 900px;
}

.workflowModalBody {
  padding: 24px;
  background-color: #f8f9fa;
}

.workflowModalHeader {
  padding: 18px 24px;
}

.modalTitleRow {
  display: flex;
  align-items: center;
  gap: 10px;
}

.modalTitle {
  font-size: 15px;
  font-weight: 700;
  margin: 0;
}

.modalSubtitle {
  color: #6c757d;
  font-size: 11px;
  margin-top: 3px;
  font-weight: 400;
}

.sectionCard {
  background-color: #fff;
  border: 1px solid #e9ecef;
  border-radius: 8px;
  margin-bottom: 18px;
}

.sectionHead {
  padding: 12px 18px;
  border-bottom: 1px solid #f1f3f5;
}

.sectionTitle {
  font-size: 12px;
  font-weight: 700;
  margin: 0;
}

.sectionCaption {
  font-size: 10px;
  color: #6c757d;
  margin: 2px 0 0 0;
}

.sectionBody {
  padding: 12px 14px 12px 18px;
  font-size: 11px;
}

.sectionBody :global(.form-control),
.sectionBody :global(.form-select),
.sectionBody :global(.rbt-input-main),
.sectionBody :global(.rbt-input-multi .rbt-input-wrapper),
.sectionBody :global(.rbt-token) {
  font-size: 10px !important;
  padding: 0.3rem 0.55rem;
  min-height: calc(1.5em + 0.55rem + 2px);
}

.sectionBody :global(.form-control::placeholder),
.sectionBody :global(.rbt-input-main::placeholder) {
  font-size: 10px !important;
}

.sectionBody :global(.form-select option),
.sectionBody :global(.rbt-menu .dropdown-item) {
  font-size: 10px !important;
}

.sectionBody :global(textarea.form-control) {
  min-height: calc(3.2em + 0.55rem + 2px);
}

.fieldRow {
  margin-bottom: 8px;
  align-items: center;
}

.fieldRowTop {
  align-items: flex-start;
}

.fieldLabelCol {
  text-align: left;
  font-size: 11px;
  font-weight: 600;
  color: #495057;
  padding-left: 6px;
  padding-right: 10px;
}

.fieldLabelCol a {
  font-weight: 600;
}

.fieldRowTop .fieldLabelCol {
  padding-top: calc(0.2rem + 1px);
}

.fieldCaption {
  font-size: 10px;
  color: #6c757d;
  margin-top: 2px;
  line-height: 1.3;
}

.requiredMark {
  color: #dc3545;
}

.modalFooterBar {
  display: flex;
  align-items: center;
  justify-content: space-between;
  margin-top: 6px;
}

.footerLeft,
.footerRight {
  display: flex;
  gap: 6px;
}

.workflowModal .modalFooterBar :global(.btn) {
  display: inline-flex !important;
  align-items: center !important;
  overflow: visible !important;
  font-size: 12px !important;
  line-height: 1.25 !important;
  padding: 0.25rem 0.55rem !important;
  min-height: 0 !important;
  border-radius: 0.25rem !important;
}

.workflowModal .buttonIcon {
  display: inline-flex;
  flex-shrink: 0;
  align-items: center;
  justify-content: center;
  line-height: 0;
  color: inherit;
  width: 14px;
  min-width: 14px;
  height: 14px;
  margin-right: 0.3rem;
  overflow: visible;
}

.workflowModal .buttonIcon :global(svg) {
  display: block;
  overflow: visible;
  flex-shrink: 0;
  width: 14px !important;
  height: 14px !important;
  min-width: 14px;
  min-height: 14px;
  fill: currentColor;
}

.switchFieldCol {
  display: flex;
  flex-direction: column;
  align-items: flex-start;
}

.switchFieldCol .fieldCaption {
  margin-top: 0;
}

.switchGroup:global(.form-check.form-switch) {
  display: flex;
  align-items: center;
  padding-left: 0;
  margin-bottom: 0;
  margin-top: 0;
  flex-shrink: 0;
}

.switchGroup:global(.form-check.form-switch) :global(.form-check-input) {
  margin-left: 0 !important;
  margin-top: 0;
  float: none;
  cursor: pointer;
  width: 2em;
  height: 1.05em;
}

.switchGroup :global(.form-check-input:disabled) {
  cursor: not-allowed;
  opacity: 1;
}

/* Off — stronger track so disabled switches stay readable */
.switchGroup :global(.form-check-input:disabled:not(:checked)) {
  background-color: #c5cdd6;
  border-color: #9aa5b1;
}

/* On — muted blue, still clearly "enabled" */
.switchGroup :global(.form-check-input:disabled:checked) {
  background-color: #4d9bff;
  border-color: #4d9bff;
}

.selectableRow {
  cursor: pointer;
}

.selectableRow:hover .tableBodyCell {
  background-color: #f8f9fa !important;
  --bs-table-bg: #f8f9fa;
  --bs-table-accent-bg: transparent;
}

.contactsCount {
  display: block;
  padding: 2px 0;
  font-size: 10px;
  color: #6c757d;
}

.descriptionColumn {
  /* !important beats react-table inline width (default ~150px). Cap so zoom-out
     doesn't stretch this column across the table. */
  min-width: 320px !important;
  width: 360px !important;
  max-width: 400px !important;
  white-space: normal !important;
  vertical-align: top;
  line-height: 1.4;
  word-break: break-word;
  overflow-wrap: anywhere;
}

.descriptionCellContent {
  max-width: 400px;
}
